import jwtDecode, { JwtPayload } from "jwt-decode";

export const isCurrentTokenValid = (accessToken) => {
  let decodedData;
  try {
    decodedData = jwtDecode<JwtPayload>(accessToken);
  } catch {
    return false;
  }
  if (!decodedData) return;
  let currentDate = new Date();
  // @ts-ignore
  return !!(accessToken && decodedData && decodedData?.exp * 1000 >= currentDate.getTime());
};